import "./consent.scss";
/* global Cookies */

class Consent {
  constructor() {
    this.name = this.constructor.name;
    // console.info(`${this.name} init!`);

    if ( !Cookies.get(this.name) ) {
      this.show();
    }
  }

  show() {
    document.addEventListener('DOMContentLoaded', () => {
      jQuery.fancybox.open({
        src  : '#consent_form',
        type : 'inline',
        opts : {
          clickOutside : false,
          clickSlide: false,
          smallBtn: false,
          buttons: false,
          touch: false,
          afterClose: () => {
            Cookies.set(this.name, true, { expires: 7 });
          }
        }
      });
    }, false);
  }

}

new Consent();



// WEBPACK FOOTER //
// ./resources/views/partials/index/popups/consent/consent.js